import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  storageUsed: (current: string, max: string) => ({
    key: 'storage-progress-bar-storageUsed',
    parameters: { current, max },
    defaultValue: '{current}/{max} GB usados',
  }),
})
